export const convertThirdAgentResponse = (res) => {
  const volantes = res.volantes.map((volante) => {
    return {
      id: volante.volante_num,
      consigneeName: volante.consignee_name,
      status: volante.third_party_billing_authorization_status,
      thirdPartyRuc: volante.third_party_ruc,
      thirdPartyName: volante.third_party_name,
      thirdPartyComment: volante.third_party_auth_rejected_comment,
    };
  });

  return {
    volantes,
    num_pages: res.num_pages,
    page: res.page,
    count: res.count,
    page_size: res.page_size,
  };
};
